var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSoundLevel2 = function SvgSoundLevel2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00002 9L4 15H8.00002L12 20V4L8.00002 9H4.00002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3486 15.9609V17H14.834V16.0908L18.0947 12.4609C18.4958 12.0143 18.8057 11.6361 19.0244 11.3262C19.2477 11.0117 19.4027 10.7314 19.4893 10.4854C19.5804 10.2347 19.626 9.97949 19.626 9.71973C19.626 9.3916 19.5576 9.09538 19.4209 8.83105C19.2887 8.56217 19.0928 8.34798 18.833 8.18848C18.5732 8.02897 18.2588 7.94922 17.8896 7.94922C17.4476 7.94922 17.0785 8.03581 16.7822 8.20898C16.4906 8.3776 16.2718 8.61458 16.126 8.91992C15.9801 9.22526 15.9072 9.57617 15.9072 9.97266H14.6426C14.6426 9.41211 14.7656 8.89941 15.0117 8.43457C15.2578 7.96973 15.6224 7.60059 16.1055 7.32715C16.5885 7.04915 17.1833 6.91016 17.8896 6.91016C18.5186 6.91016 19.0563 7.02181 19.5029 7.24512C19.9495 7.46387 20.2913 7.77376 20.5283 8.1748C20.7699 8.57129 20.8906 9.03613 20.8906 9.56934C20.8906 9.861 20.8405 10.1572 20.7402 10.458C20.6445 10.7542 20.5101 11.0505 20.3369 11.3467C20.1683 11.6429 19.9701 11.9346 19.7422 12.2217C19.5189 12.5088 19.2796 12.7913 19.0244 13.0693L16.3584 15.9609H21.3486Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoundLevel2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound-level 2.bcd115be.svg";
export { ForwardRef as ReactComponent };